import React from "react";
import classes from "./ApplicationComissionInfo.module.css";
import { ApplicationComissionName } from "./items/ApplicationComissionName";
import { ApplicationComissionValue } from "./items/ApplicationComissionValue";
import { IApplicationComissionInfoProps } from "../../../../interfaces/Ui/Application/IApplicationComissionInfoProps/IApplicationComissionInfoProps";

export const ApplicationCommissionInfo = ({
  title = "Информация",
  fields,
  titleProps,
  fieldListContainerProps,
  ...restProps
}: IApplicationComissionInfoProps) => {
  const concatTitleClassName = `${ classes.titleComission } ${ titleProps?.className ? titleProps.className : "" }`;

  const fieldsListContainerClassName = `${ classes.info } ${ fieldListContainerProps?.className ? fieldListContainerProps.className : "" }`;
  return (
    <div { ...restProps }>
      <div { ...titleProps } className={ concatTitleClassName }>
        {title}
      </div>
      <div
        className={ fieldsListContainerClassName }
        {...fieldListContainerProps}
      >
        { fields.map((el, id) => {
          return (
            <React.Fragment  key={ id }>
              <ApplicationComissionName>{ el.name }</ApplicationComissionName>
              <ApplicationComissionValue>{ el.value }</ApplicationComissionValue>
            </React.Fragment >
          );
        }) }
      </div>
    </div>
  );
};
